<!--IF WALLET NOT CONNECTED -->
<div *ngIf="data" class="wallet-connect-wrapper">
    <p *ngIf="!isWalletConnected" class="text-center">Connect your wallet</p>
    <div class="wallet-connect-button-wrapper">
      <w3m-core-button></w3m-core-button>
    </div>
  </div>
  
  <!--IF WALLET CONNECTED -->
  <div *ngIf="isWalletConnected" class="wallet-connect-wrapper">
    <!-- Show loading spinner while loading -->
    <app-loading *ngIf="isLoading"></app-loading>
 
    <!-- Show content if not loading -->
    <ng-container *ngIf="!isLoading">
      <!--IF NFT OWNER -->
      <ng-template [ngIf]="walletConnectStatus === true">
        <app-content-control *ngIf="controls" [contentControls]="controls"></app-content-control>
      </ng-template>
  
      <!-- IF NOT NFT OWNER -->
      <ng-template [ngIf]="walletConnectStatus === false">
        <p class="text-center">NFT is not present in your wallet</p>
      </ng-template>
    </ng-container>
  </div>
  